import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SlimScrollModule } from 'ng2-slimscroll';
import { OnBoardingModule } from './../on-boarding/on-boarding.module';
import { TabsModule } from 'ng2-bootstrap/components/tabs';
import { LoyaltySummaryListComponent } from './summary-list/summary-list.component';
import { SharedModule } from '../shared/shared.module';
import { LoyaltyRoutingModule } from './loyalty-routing.module';
import { LoyaltyService } from './loyalty.service';
import { LoyaltySummaryDetailComponent } from './summary-details/summary-detail.component';
@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    LoyaltyRoutingModule,
    SlimScrollModule,
    OnBoardingModule,
    TabsModule
  ],
  exports: [
  ],
   providers: [
    LoyaltyService
   ],
  declarations: [LoyaltySummaryListComponent, LoyaltySummaryDetailComponent]
})
export class LoyaltyModule { }



// WEBPACK FOOTER //
// ./src/app/loyalty/loyalty.module.ts